<div class="dialogo">
    <h1 mat-dialog-title class="titulo">Agregar Destinatarios o Validaciones</h1>
    <div mat-dialog-content>

        <div  style="padding-bottom: 5px; padding-top: 5px;" *ngIf="!finalizado">
            <button color="primary" type="button" mat-raised-button (click)="fileInput.click()" [disabled]="ejecutando"
                style="background-color: #108f5a;padding-bottom: 5px; padding-top: 5px">Seleccionar archivo
                <mat-icon >upload_file</mat-icon>
            </button>
            <input hidden (change)="onFileSelected($event)" #fileInput type="file" accept=".xls,.xlsx">
            
        </div>
        <div  style="padding-bottom: 5px; padding-top: 5px;" *ngIf="!ejecutando">
            <span class="file-name">{{selectedFile?.name}}</span>
        </div>
        <div  style="padding-bottom: 5px; padding-top: 5px;" *ngIf="ejecutando">
            <span class="file-name-ejecutando">{{selectedFile?.name}}</span>
        </div>
        <div  style="padding-bottom: 5px; padding-top: 5px;" *ngIf="mostrarMensajeEjecutando">
            <span class="waiting">Procesando importación. Por favor espere un momento</span>
        </div>
        <div  class="mensajeExitoso" *ngIf="finalizado && exitoso">
            <div>
                <span ><mat-icon mat-list-icon class="waiting" >warning</mat-icon>La importación se actualizó correctamente.</span>
            </div>
        </div>
        <div  style="padding-bottom: 5px; padding-top: 5px;" *ngIf="error">
            <div *ngIf="errores.length > 0">
                <br>
                <span class="error">Error al realizar la operación solicitada</span>
                <mat-list>
                    <mat-list-item *ngFor="let error of errores">
                        <span class="error">{{error}}</span>
                    </mat-list-item>
                </mat-list>
            </div>
            <div *ngIf="erroresDestinatarios.length > 0">
                <br>
                <span class="error">Error al realizar la importación de destinatarios</span>
                <mat-list>
                    <mat-list-item *ngFor="let error of erroresDestinatarios">
                        <span class="error">{{error}}</span>
                    </mat-list-item>
                </mat-list>
            </div>
            <div *ngIf="erroresValidaciones.length > 0">
                <br>
                <span class="error">Error al realizar la importación de validaciones</span>
                <mat-list>
                    <mat-list-item *ngFor="let error of erroresValidaciones">
                        <span class="error">{{error}}</span>
                    </mat-list-item>
                </mat-list>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
            <span class="padding-right-10" *ngIf="!finalizado">
                <button mat-raised-button color="primary" (click)="importar()" [disabled]="!habilitarBotonImportar"
                    [ngStyle]="habilitarBotonImportar?{'background-color': '#3f51b5'} : {'background-color': 'rgba(0,0,0,.12)','color':'#3a3737','font-size':'14px'}"
                    style="padding-bottom: 5px; padding-top: 5px;margin-right: 10px;">
                    Importar Destinatarios/Validaciones
                    <mat-icon >file_upload</mat-icon>
                </button>
            </span>
            <span class="padding-right-10" *ngIf="!finalizado">
                <button mat-raised-button  style="padding-bottom: 5px; padding-top: 5px;" (click)="cancelarAceptar()">
                    Cancelar
                    <mat-icon >cancel</mat-icon>
                </button>
            </span>
            <span class="padding-right-10" *ngIf="finalizado">
                <button mat-raised-button color="primary" style="padding-bottom: 5px; padding-top: 5px;" (click)="cancelarAceptar()">
                    Aceptar
                </button>
            </span>
    </div>
</div>

